import React from "react";
import { Tag } from "antd";
export default function DeactivatedTag({ big = false }) {
    return (React.createElement(Tag, { color: "red", style: { fontSize: big ? 20 : "14px", padding: big ? 5 : 2 } }, "Deactivated"));
}
DeactivatedTag.defaultProps = {
    big: false,
};
